import { useLazyQuery, useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import { ConnectionStatus } from "../api/graphql";
import { useServerEvent } from "../lib/serverEventsProvider";
import { useCurrentInmateSystemId } from "../SessionBoundary";
import { GetConnectionActivityUpdateDocument } from "./GetConnectionActivityUpdate.generated";
import { GetConnectionsListDocument } from "./GetConnectionsList.generated";
import { useMessageBadges } from "./MessageBadgeProvider";

export default function useConnectionsList() {
  const badges = useMessageBadges();
  const systemId = useCurrentInmateSystemId();

  // fetch and refresh contacts list on navigation
  const { data } = useQuery(GetConnectionsListDocument, {
    fetchPolicy: "cache-and-network",
    variables: { systemId },
  });

  // grab updates when notified
  const [updateConnectionActivity] = useLazyQuery(
    GetConnectionActivityUpdateDocument,
    { fetchPolicy: "network-only" }
  );
  useServerEvent("updateConnectionTimeline", ({ id }) => {
    updateConnectionActivity({
      variables: { connectionId: id },
    });
  });

  return useMemo(
    () =>
      data?.currentCorrespondent?.connections
        .filter((c) => c.status === ConnectionStatus.Active)
        .sort(
          (a, b) =>
            b.lastMessageCenterActivityAt - a.lastMessageCenterActivityAt
        )
        .map((c) => ({
          ...c,
          messages: {
            unreadMessageCount: badges.unread(c.id),
          },
        })),
    [data, badges]
  );
}
